import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-[#F8F9FA] py-8 md:py-14 px-4" data-id="element-68">
      <div className="max-w-3xl mx-auto" data-id="element-69">
        <div className="bg-white p-6 rounded-xl text-center border border-gray-200" data-id="element-70">
          <ShieldCheckIcon className="w-14 h-14 text-[#22C55E] mx-auto mb-3" data-id="element-71" />
          <h2 className="text-2xl md:text-3xl font-bold text-[#1A1A2E] mb-3" data-id="element-72">
            GARANTÍA 7 DÍAS
          </h2>
          <p className="text-lg text-[#4A4A5A]" data-id="element-73">
            Prueba el material. Si no es para ti, solicita la devolución dentro
            de 7 días.
          </p>
        </div>
      </div>
    </section>;
}